import { useDesignMaxTheme } from "@/packages";
import { FONT } from "@/styles";
import { Center, Flex, Text } from "@chakra-ui/react";
import { useState } from "react";
import { OtherRoomInfos, OtherRoomPhotos } from "./components";
import { type OtherRoomPreviewProps } from "./otherRoomPreview.type";

export const OtherRoomPreView = ({ rooms }: OtherRoomPreviewProps) => {
    const [currentIdx, setCurrentIdx] = useState(0);
    const { MEDIAS } = useDesignMaxTheme();
    const { isMobile } = MEDIAS();
    // const { ref, inView } = useInView({ threshold: 0.9, delay: 0.3, triggerOnce: true });

    const nextSlide = () => {
        if (rooms) setCurrentIdx((prev) => (prev === (rooms.length as number) - 1 ? 0 : prev + 1));
    };
    const prevSlide = () => {
        if (rooms) setCurrentIdx((prev) => (prev === 0 ? (rooms.length as number) - 1 : prev - 1));
    };
    return (
        <Center position="relative" w="100%">
            <Center as="section" p={isMobile ? "40px 0" : "100px 160px"}>
                <Flex position="relative" flexDir={isMobile ? "column" : "row"} p={isMobile ? "0" : "0 48px"}>
                    <Text
                        padding="0 44px"
                        position={isMobile ? "relative" : "absolute"}
                        top="0"
                        right="0"
                        color="#fbf6f2"
                        {...FONT("cormorant", isMobile ? 40 : 104, 700, 1.2)}
                        sx={{ writingMode: isMobile ? "none" : "vertical-rl" }}
                    >
                        OTHER
                    </Text>
                    <OtherRoomPhotos rooms={rooms} currentIdx={currentIdx} />
                    <OtherRoomInfos rooms={rooms} currentIdx={currentIdx} nextSlide={nextSlide} prevSlide={prevSlide} />
                </Flex>
            </Center>
        </Center>
    );
};
